/* Print product page (template product.print ONLY; loaded behind the template-suffix check in layout/theme.liquid).
   Presentation only. The theme's own Size / Type / Frame Options radio inputs, form, window-mount tick box and
   Add to Cart button stay the source of truth: every tile below just clicks the matching real radio, so variant IDs,
   prices, the window-mount cart logic and the order data are exactly what they were. Nothing here builds a form or
   sets a price.

   Underlying variants (Size / Type / Frame Options):
     Fine Art Print    x Unframed | Black | White | Light Oak Look | Dark Kiaat Look | Walnut
     Mounted Canvas    x Unframed | Black | White | Light Oak Look | Dark Kiaat Look   (Unframed = mounted, ready to hang)
     Canvas Print Only x Unframed                                                       (new; 40 mm mirror bleed, in a tube)
   A tile whose variant does not exist on a product is simply not shown, so this page works on today's products
   (no Walnut, no print-only) and on the extended ones. If the product does not have Size / Type / Frame Options,
   nothing here runs and the theme's own pickers stay. */
(function () {
  'use strict';

  var IMG = window.sgPrImg || {};
  var FA = 'Fine Art Print', MC = 'Mounted Canvas', CPO = 'Canvas Print Only', UNF = 'Unframed';
  var KEY = { 'black': 'black', 'white': 'white', 'light oak look': 'oak', 'dark kiaat look': 'kiaat', 'walnut': 'walnut' };
  var PAPER_NAME = { 'Dark Kiaat Look': 'Warm Kiaat Look' };   // display only; the option value is unchanged
  var S = { lastPaper: null, lastCanvas: null };
  // 'GB' / 'EU' / 'US' from product-template.liquid's data-sg-region (sg-overseas-region); '' for South Africa,
  // where every branch below that tests OS keeps the page exactly as it was.
  var OS = '';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function variants() {
    var out = null;
    $$('[data-product-blocks] textarea.hide, textarea[data-variant-json]').some(function (t) {
      try { var j = JSON.parse(t.value || t.textContent); if (Array.isArray(j) && j.length && j[0].options) { out = j; return true; } } catch (e) {}
      return false;
    });
    return out || [];
  }

  var W = {};          // wrappers: size, type, frame
  function findWrappers() {
    $$('.variant-wrapper').forEach(function (w) {
      var l = (($('.variant__label', w) || {}).textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (/^size/.test(l)) W.size = w; else if (/^type/.test(l)) W.type = w; else if (/frame/.test(l)) W.frame = w;
    });
    return W.size && W.type && W.frame;
  }
  function radios(w) { return $$('input[type=radio]', w); }
  function radio(w, v) { return radios(w).filter(function (r) { return r.value === v; })[0]; }
  function val(w) { var c = radios(w).filter(function (r) { return r.checked; })[0]; return c ? c.value : null; }
  function pick(w, v) { var r = radio(w, v); if (r && !r.checked) r.click(); return !!r; }
  function sel() { return { size: val(W.size), type: val(W.type), frame: val(W.frame) }; }
  function vfor(size, type, frame) {
    return variants().filter(function (v) { return v.options[0] === size && v.options[1] === type && v.options[2] === frame; })[0] || null;
  }
  function setChoice(type, frame) {
    // Always route through Unframed, which exists for every type, so a sparse variant set never lands on a gap.
    if (val(W.type) !== type) { pick(W.frame, UNF); pick(W.type, type); }
    pick(W.frame, frame);
  }

  var useRand = function () { return /^\s*R\s?\d/.test((($('[data-product-price]') || {}).textContent || '')); };
  function rand(cents) { return 'R' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function priceOf(v) {
    // Overseas the main price is £/€/$ (snippets/sg-overseas-price.liquid), so tiles show that amount, or none; never rand.
    if (OS) return v && window.sgOsAmount ? (window.sgOsAmount(v) || '') : '';
    return v && useRand() ? rand(v.price) : '';
  }
  /* Overseas only: a size with no variant in the chosen medium is hidden (paper squares are 100 x 100 cm only overseas,
     so 30 x 30 cm on paper was a dead end reading "Unavailable"), and switching medium moves to a size that medium has. */
  function hasMedium(size, paper) { return paper ? !!vfor(size, FA, UNF) : !!(vfor(size, MC, UNF) || vfor(size, CPO, UNF)); }
  function sizeFor(paper) {
    var cur = val(W.size);
    if (hasMedium(cur, paper)) return cur;
    return radios(W.size).map(function (r) { return r.value; }).filter(function (x) { return hasMedium(x, paper); })[0] || cur;
  }
  function osSizes() {
    if (!OS) return;
    var paper = val(W.type) === FA;
    radios(W.size).forEach(function (r) {
      var box = r.closest('.variant-input') || r.parentElement;
      box.style.display = hasMedium(r.value, paper) ? '' : 'none';
    });
  }
  /* The theme's own label for a radio. Overseas pages relabel values in Liquid (variant-button.liquid: frames
     per settings.sg_os_frame_labels, "Dark Kiaat Look" -> "Dark Oak"; US sizes in inches per
     snippets/sg-us-size-labels.liquid), so a label that differs from its value is the overseas name and wins.
     South Africa: label == value, so the names below are unchanged there. */
  function shown(w, v) {
    var r = w && radio(w, v), l = r && r.parentElement && r.parentElement.querySelector('label');
    return l ? (l.getAttribute('data-sg-orig') || l.textContent).replace(/\s+/g, ' ').trim() : '';
  }
  function frameName(v, paper) {
    var t = shown(W.frame, v);
    if (t && t !== v) return t;
    return paper && PAPER_NAME[v] ? PAPER_NAME[v] : v;
  }

  function tile(o) {
    // o: {img, name, sub, price, on, off, id}
    return '<button type="button" class="sg-pr-tile' + (o.img ? '' : ' sg-pr-tile--text') + '" data-act="' + o.id + '" aria-pressed="' + (o.on ? 'true' : 'false') + '"' + (o.off ? ' disabled' : '') + '>' +
      (o.img ? '<span class="sg-pr-tile__img" style="background-image:url(' + o.img + ')"></span>' : '') +
      '<span class="sg-pr-tile__name">' + esc(o.name) + '</span>' +
      (o.sub ? '<span class="sg-pr-tile__sub">' + esc(o.sub) + '</span>' : '') +
      (o.price ? '<span class="sg-pr-tile__price">' + o.price + '</span>' : '') + '</button>';
  }
  function step(label, sub, cls, tiles, selected) {
    if (selected) S.selHtml = selected;     // shown under the price row, not under the tiles
    return '<div class="sg-pr-step"><p class="sg-pr-lab">' + label + '</p>' + (sub ? '<p class="sg-pr-sub">' + sub + '</p>' : '') +
      '<div class="sg-pr-grid ' + cls + '">' + tiles + '</div>' + '</div>';
  }

  /* The mount tick box is the theme's (it adds the mount's own variant to the cart). We show it as two cards. */
  function mountState() {
    var cb = $('#window-mount-checkbox'), box = $('#window-mount-option');
    var ok = !!cb && !!box && box.style.display !== 'none';
    var label = ok ? (($('.window-mount-label span', box) || {}).textContent || '') : '';
    var mm = (/(\d+)\s*mm/i.exec(label) || [])[1];
    var price = (/\(\+\s*R\s*([\d.,]+)\)/.exec(label) || [])[1];
    return { ok: ok, on: !!(cb && cb.checked), mm: mm, price: price ? 'R' + Math.round(parseFloat(price.replace(/,/g, ''))) : '' };
  }
  function setMount(on) {
    var cb = $('#window-mount-checkbox'); if (!cb || cb.checked === on) return;
    cb.checked = on;
    cb.dispatchEvent(new Event('change', { bubbles: true }));
  }

  var root;
  function render() {
    if (!root) return;
    var s = sel(), paper = s.type === FA, kind;
    var h = '';
    var sizeP = s.size;
    // only offer a medium the product really has (some products are a single fine art print)
    var hasCanvas = !!radio(W.type, MC) || !!radio(W.type, CPO);
    var mat = hasCanvas ? step('Select print medium', '', 'sg-pr-grid--2',
      tile({ id: 'mat-paper', name: 'Fine Art Paper', on: paper }) +
      tile({ id: 'mat-canvas', name: 'Premium Canvas', on: !paper }), '') : '';
    h += mat;

    function frameList(type) {
      return radios(W.frame).map(function (r) { return r.value; }).filter(function (v) { return v !== UNF && vfor(sizeP, type, v); });
    }
    function sold(v) { return v && v.available === false; }
    if (paper) {
      var frames = frameList(FA), framed = s.frame !== UNF;
      var m = mountState();
      var fimg = function (v) { return IMG[(m.ok && m.on ? 'fm3-' : 'fa3-') + KEY[v.toLowerCase()]] || IMG['fa3-' + KEY[v.toLowerCase()]]; };
      var sp = priceOf(vfor(sizeP, FA, s.frame));
      // with a window mount on, the line shows frame + mount, the same total as the main price
      if (!OS && framed && m.ok && m.on && m.price && vfor(sizeP, FA, s.frame) && useRand()) sp = rand(vfor(sizeP, FA, s.frame).price + parseInt(m.price.replace(/\D/g, ''), 10) * 100);
      h += step('Select artwork finish', '', 'sg-pr-grid--auto',
        tile({ id: 'p-unf', img: IMG['fa-tube'], name: 'Unframed', sub: 'Print only', price: priceOf(vfor(sizeP, FA, UNF)), on: !framed }) +
        frames.map(function (v) { var vv = vfor(sizeP, FA, v); return tile({ id: 'f:' + v, img: fimg(v), name: frameName(v, true) + ' Frame', sub: 'Behind glass', price: priceOf(vv), on: s.frame === v, off: sold(vv) }); }).join(''),
        'Selected: <b>' + (framed ? 'Fine Art Paper Print, ' + esc(frameName(s.frame, true)) + ' frame behind glass' + (m.ok && m.on ? ', ' + (m.mm || '') + ' mm white mount' : '') : 'Fine Art Paper Print, unframed') + '</b>' + (sp ? ' &middot; ' + sp : ''));
      if (framed && m.ok) {
        var mm = m.mm || '30';
        var fk = KEY[s.frame.toLowerCase()];
        h += step('Add a ' + mm + ' mm white window mount?', '', 'sg-pr-grid--auto',
          tile({ id: 'm-no', img: IMG['fa3-' + fk], name: 'No mount', on: !m.on }) +
          tile({ id: 'm-yes', img: IMG['fm3-' + fk], name: 'White mount', sub: m.price ? '+' + m.price : '', on: m.on }), '');
      }
      kind = framed ? 'Fine Art Paper Print · ' + frameName(s.frame, true) + ' frame' + (m.ok && m.on ? ' · ' + (m.mm || '') + ' mm mount' : '') : 'Fine Art Paper Print · Unframed';
    } else {
      var cfr = frameList(MC), isPO = s.type === CPO, floater = s.type === MC && s.frame !== UNF;
      var hasPO = !!radio(W.type, CPO) && !!vfor(sizeP, CPO, UNF);
      var cp = priceOf(isPO ? vfor(sizeP, CPO, UNF) : vfor(sizeP, MC, s.frame));
      h += step('Select artwork finish', '', 'sg-pr-grid--auto',
        (hasPO ? tile({ id: 'c-po', img: IMG['po2'], name: 'Print only', sub: 'Unframed', price: priceOf(vfor(sizeP, CPO, UNF)), on: isPO }) : '') +
        tile({ id: 'c-mc', img: IMG['lca-unframed'], name: 'Mounted', sub: 'Ready to hang', price: priceOf(vfor(sizeP, MC, UNF)), on: s.type === MC && s.frame === UNF }) +
        cfr.map(function (v) { var vv = vfor(sizeP, MC, v); return tile({ id: 'f:' + v, img: IMG['lca-' + KEY[v.toLowerCase()]], name: frameName(v, false) + ' Frame', sub: 'Floater', price: priceOf(vv), on: floater && s.frame === v, off: sold(vv) }); }).join(''),
        'Selected: <b>' + (isPO ? 'Premium Canvas Print Only, unmounted, unframed' : floater ? 'Premium Canvas, mounted, ' + esc(OS ? frameName(s.frame, false) : s.frame) + ' floater frame' : 'Premium Canvas, mounted, unframed') + '</b>' + (cp ? ' &middot; ' + cp : ''));
      kind = isPO ? 'Premium Canvas Print Only · Unmounted, unframed' : floater ? 'Premium Canvas · Mounted · ' + frameName(s.frame, false) + ' floater frame' : 'Premium Canvas · Mounted, unframed';
    }
    root.innerHTML = h;
    root.setAttribute('data-kind', kind);
    osSizes();   // overseas: hide sizes the chosen medium does not have (no-op in South Africa)
    var sel2 = $('#sg-pr-selected'); if (sel2) sel2.innerHTML = S.selHtml || '';
  }

  function onClick(e) {
    var b = e.target.closest('[data-act]'); if (!b || b.disabled) return;
    var a = b.getAttribute('data-act'), s = sel();
    if (a === 'mat-paper') { if (s.type !== FA) { if (OS) pick(W.size, sizeFor(true)); setChoice(FA, UNF); } }   // overseas: first move to a size paper has
    else if (a === 'mat-canvas') { if (s.type === FA) { var cs = OS ? sizeFor(false) : s.size; if (OS) pick(W.size, cs); setChoice(radio(W.type, CPO) && vfor(cs, CPO, UNF) ? CPO : MC, UNF); } }   // opens on Print only, the cheapest canvas (Craig 2026-10-20)
    else if (a === 'p-unf') { setMount(false); setChoice(FA, UNF); }
    else if (a === 'c-po') setChoice(CPO, UNF);
    else if (a === 'c-mc') setChoice(MC, UNF);
    else if (a.indexOf('f:') === 0) { setChoice(s.type === FA ? FA : MC, a.slice(2)); }
    else if (a === 'm-yes') setMount(true);
    else if (a === 'm-no') setMount(false);
    setTimeout(function () { render(); sync(); }, 90);
  }

  /* Size buttons: "A4" with "21 × 29.7 cm" under it (display only; the option value is unchanged). */
  function sizeLabels() {
    $$('.variant-input label', W.size).forEach(function (l) {
      if (l.children.length) return;
      var t = l.textContent.replace(/\s+/g, ' ').trim();
      l.setAttribute('data-sg-orig', t);
      var m = /^(A\d)\s*-\s*(.+)$/i.exec(t);
      var dims = (m ? m[2] : t).replace(/\s*x\s*/ig, ' × ').replace(/(\d)\s*cm\s*$/i, '$1 cm');
      l.innerHTML = m ? '<span class="sg-pr-size__a">' + m[1] + '</span><span class="sg-pr-size__d">' + dims + '</span>' : '<span class="sg-pr-size__a sg-pr-size__a--sq">' + dims + '</span>';
    });
  }

  function renameTabs() {
    $$('.collapsible-trigger-btn').forEach(function (b) {
      var t = b.childNodes[0];
      if (t && t.nodeType === 3 && /^\s*description\s*$/i.test(t.textContent)) t.textContent = 'About this artwork';
    });
  }

  function fmt(t) {
    var m = /^\s*R\s?([\d,]+)\.(\d\d)\s*$/.exec(t || ''); if (!m) return null;
    var whole = m[1].replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R' + whole + (m[2] === '00' ? '' : '.' + m[2]);
  }
  function priceFormat() {
    var el = $('[data-product-price]'); if (!el) return;
    var apply = function () { var n = fmt(el.textContent); if (n && el.textContent.trim() !== n) el.textContent = n; };
    apply(); new MutationObserver(apply).observe(el, { childList: true, characterData: true, subtree: true });
  }

  function dispatchBox() {
    var box = $('[data-product-blocks] .sg-dispatch'), atc = $('[data-product-blocks] .add-to-cart');
    if (!box || !atc || !$('.sg-dispatch__free', box)) return;
    var anchor = atc.closest('.payment-buttons') || atc;
    anchor.parentNode.insertBefore(box, anchor);
    box.classList.add('sg-lca-box');
    var free = $('.sg-dispatch__free', box); if (free) free.textContent = 'Free nationwide delivery';
    var d = $('.sg-dispatch__date', box);
    var tidy = function () {
      if (!d || !d.firstChild || d.firstChild.nodeType !== 3) return;
      var t = d.firstChild.textContent, n = t.replace(/\s*Dispatch Date:\s*$/i, ' dispatch: ');
      if (n !== t) d.firstChild.textContent = n;
    };
    tidy(); if (d) new MutationObserver(tidy).observe(d, { childList: true, characterData: true, subtree: true });
  }

  /* The price row (price, "Tax and delivery included", spec sheet link) sits directly above Add to Cart,
     below the grey delivery box, so it is on screen when the shopper reaches the button (Craig, 2026-10-19). */
  function priceAboveCart() {
    var pr = $('[data-product-blocks] [data-product-price]'), atc = $('[data-product-blocks] .add-to-cart');
    if (!pr || !atc) return;
    var pb = pr.closest('.product-block'); if (!pb) return;
    var anchor = atc.closest('.payment-buttons') || atc;
    if (pb.contains(anchor) || anchor.contains(pb)) return;
    anchor.parentNode.insertBefore(pb, anchor);
    pb.classList.add('sg-pr-pricebar');
    if (!$('#sg-pr-selected')) {
      var se = document.createElement('p'); se.id = 'sg-pr-selected'; se.className = 'sg-pr-selected'; se.setAttribute('aria-live', 'polite');
      pb.parentNode.insertBefore(se, pb.nextSibling);
    }
  }

  /* The tab drawers (About this artwork open, Specifications, Delivery, Care, Ask a question) run full width across the
     screen once the buying column ends, like Pottery Barn (Craig, 2026-10-19). Until then the artwork stays put on the left. */
  function openAbout() {
    var b = $$('.collapsible-trigger-btn').filter(function (x) { return /about this artwork/i.test(x.textContent); })[0];
    if (b && b.getAttribute('aria-expanded') !== 'true' && !b.classList.contains('is-open')) b.click();
  }

  var barSync = function () {};
  function sync() { barSync(); }
  function stickyBar() {
    var atc = $('[data-product-blocks] [name=add], [data-product-blocks] .add-to-cart');
    if (!atc || $('.sg-lca-sticky')) return;
    var bar = document.createElement('div');
    bar.className = 'sg-lca-sticky'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML = '<div class="sg-lca-sticky__info"><span class="sg-lca-sticky__frame"></span><span class="sg-lca-sticky__price"></span></div><button type="button" class="sg-lca-sticky__btn">Add to cart</button>';
    document.body.appendChild(bar);
    var btn = $('.sg-lca-sticky__btn', bar);
    barSync = function () {
      var price = (($('[data-product-price]') || {}).textContent || '').replace(/\s+/g, ' ').trim();
      // Overseas: the same £/€/$ amount the main price block shows (its rand line stays there); rand only when that block has fallen back to rand.
      var osAmt = OS && $('[data-sg-os-price][data-sg-os-state="on"] [data-sg-os-amount]');
      if (osAmt && osAmt.textContent.trim()) price = osAmt.textContent.trim();
      $('.sg-lca-sticky__price', bar).textContent = price;
      var sz = val(W.size) || '';
      var lab = shown(W.size, sz);   // US: "12 x 16 in" (see shown())
      var short = lab && lab !== sz ? lab.replace(/\s*x\s*/ig, ' × ') : (/^(A\d)/i.exec(sz) || [])[1] || sz.replace(/\s*x\s*/ig, ' × ').replace(/(\d)\s*cm\s*$/i, '$1 cm');
      $('.sg-lca-sticky__frame', bar).textContent = short + ' · ' + ((root && root.getAttribute('data-kind')) || '');
      var disabled = atc.disabled || atc.getAttribute('aria-disabled') === 'true';
      btn.disabled = !!disabled;
      btn.textContent = disabled ? (($('[data-add-to-cart-text]', atc) || atc).textContent.trim() || 'Sold out') : 'Add to cart';
    };
    function setVisible(on) { bar.classList.toggle('is-visible', on); document.documentElement.style.setProperty('--lca-sticky-h', on ? bar.offsetHeight + 'px' : '0px'); }
    btn.addEventListener('click', function () { if (!btn.disabled) atc.click(); });
    var past = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { var e = es[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0; setVisible(past && window.innerWidth <= 768); }, { threshold: 0 }).observe(atc);
    }
    window.addEventListener('resize', function () { setVisible(past && window.innerWidth <= 768); });
    new MutationObserver(barSync).observe(atc, { attributes: true, childList: true, subtree: true });
    var pr = $('[data-product-price]'); if (pr) new MutationObserver(barSync).observe(pr, { childList: true, characterData: true, subtree: true });
    var osBox = OS && $('[data-sg-os-price]'); if (osBox) new MutationObserver(barSync).observe(osBox, { attributes: true, childList: true, characterData: true, subtree: true });   // overseas amount changes after the rand price
    barSync();
  }

  function init() {
    var blocks = $('[data-product-blocks]'); if (!blocks) return;
    if (!findWrappers()) return;                                   // not a Size / Type / Frame Options product: leave the theme's pickers alone
    var sec = blocks.closest('[data-sg-region]'); OS = sec ? sec.getAttribute('data-sg-region') : '';
    var types = radios(W.type).map(function (r) { return r.value; });
    if (types.indexOf(FA) < 0) return;
    if (types.some(function (x) { return [FA, MC, CPO].indexOf(x) < 0; })) return;   // older option sets (e.g. Premium Polycanvas) keep the theme's pickers
    document.documentElement.classList.add('sg-lca', 'sg-pr');
    W.type.classList.add('sg-pr-native'); W.frame.classList.add('sg-pr-native');
    root = document.createElement('div'); root.className = 'sg-pr-steps'; root.id = 'sg-pr-steps';
    // US: the crop note (product-template.liquid) stays directly under the size buttons, above the finish tiles
    var after = W.size.nextElementSibling && W.size.nextElementSibling.classList.contains('sg-osa-crop-note') ? W.size.nextElementSibling : W.size;
    after.parentNode.insertBefore(root, after.nextSibling);
    root.addEventListener('click', onClick);
    var sl = $('.variant__label', W.size); if (sl) { var n0 = sl.firstChild; if (n0 && n0.nodeType === 3) n0.textContent = 'Select size'; else sl.textContent = 'Select size'; }
    sizeLabels(); renameTabs(); priceFormat(); dispatchBox(); priceAboveCart();
    render(); stickyBar();
    // end of the buying column: drop the empty trailing block and the margin under Share, so the artwork ends level with the Share row
    var last = blocks.lastElementChild;
    if (last && last.getBoundingClientRect().height < 2) last.classList.add('sg-pr-empty');
    var sh = $('.social-sharing', blocks), shb = sh && sh.closest('.product-block'); if (shb) shb.classList.add('sg-pr-share');
    var setTop = function () { var h = $('#SiteHeader'); document.documentElement.style.setProperty('--sg-pr-sticky-top', ((h ? h.offsetHeight : 0) + 20) + 'px'); };
    setTop(); window.addEventListener('resize', setTop); window.addEventListener('load', setTop);
    document.addEventListener('change', function (e) {
      if (e.target.closest('.variant-wrapper') || e.target.id === 'window-mount-checkbox') setTimeout(function () { sizeLabels(); render(); sync(); }, 90);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
